module.exports = __webpack_public_path__ + "img/muchbetter.41b8442d.svg";